/** The `photo_points` kind's options (backend `viewer/report_kinds.py`, PHOTO_POINTS_OPTIONS) as the page reads them. */
export type PhotoSection = 'map' | 'overview' | 'quality' | 'georeferencing' | 'positioning' | 'histograms' | 'altitude';
export const PHOTO_SECTIONS: PhotoSection[] = ['map', 'overview', 'quality', 'georeferencing', 'positioning', 'histograms', 'altitude'];

export interface PhotoPointsConfig {
  sections: Record<PhotoSection, { enabled: boolean }>;
}

const isObject = (v: unknown): v is Record<string, unknown> => v !== null && typeof v === 'object' && !Array.isArray(v);

/** The stored options over the defaults: a report saved before a section existed still shows it. */
export function photoPointsConfig(raw: unknown): PhotoPointsConfig {
  const stored = isObject(raw) && isObject(raw.sections) ? raw.sections : {};
  const sections = Object.fromEntries(
    PHOTO_SECTIONS.map((s) => {
      const v = stored[s];
      return [s, { enabled: isObject(v) && typeof v.enabled === 'boolean' ? v.enabled : true }];
    }),
  ) as PhotoPointsConfig['sections'];
  return { sections };
}
